var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRechargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48485 14.4516C8.08319 14.4516 7.75758 14.7982 7.75758 15.2258C7.75758 15.6534 8.08319 16 8.48485 16H14.303C15.2402 16 16 15.1912 16 14.1935V1.80645C16 0.808776 15.2402 0 14.303 0H8.48485C8.08319 0 7.75758 0.34662 7.75758 0.774195C7.75758 1.20177 8.08319 1.54839 8.48485 1.54839L14.303 1.54839C14.4369 1.54839 14.5455 1.66393 14.5455 1.80645L14.5455 14.1935C14.5455 14.3361 14.4369 14.4516 14.303 14.4516H8.48485Z",
    fill: "#2246DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.15119C0 9.86382 0.542684 10.4415 1.21212 10.4415H5.68494C5.69127 10.5173 5.69789 10.5931 5.70481 10.6688L5.7572 11.2426C5.83713 12.1181 6.71044 12.6424 7.45558 12.2623C9.04028 11.4538 10.5711 10.2406 11.7866 8.8896C12.2367 8.38929 12.2367 7.60029 11.7866 7.09999L11.6904 6.99307C10.4749 5.6421 9.04028 4.53578 7.45558 3.72732C6.71044 3.34718 5.83713 3.87148 5.7572 4.74694L5.70481 5.32076C5.69789 5.39651 5.69127 5.47228 5.68494 5.54808L1.21212 5.54808C0.542685 5.54808 0 6.12578 0 6.8384V9.15119ZM7.0819 9.58006C7.04069 9.19095 6.73098 8.89313 6.35924 8.89313H1.45455L1.45455 7.09647H6.35924C6.74333 7.09647 7.0612 6.77854 7.08511 6.37047C7.1027 6.0702 7.12517 5.77018 7.15253 5.47054L7.16774 5.30399C8.43303 5.99813 9.58464 6.90674 10.5772 7.99479C10.1628 8.44909 9.72062 8.8721 9.25405 9.26128C8.60316 9.8042 7.90474 10.2813 7.16774 10.6856L7.15253 10.519C7.12517 10.2194 7.1027 9.91939 7.08511 9.61913C7.08434 9.60601 7.08327 9.59299 7.0819 9.58006Z",
    fill: "#2246DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeIcon);
export default __webpack_public_path__ + "static/media/recharge-icon.c8b27be493ab0348d7daf73f6c0ad734.svg";
export { ForwardRef as ReactComponent };